export const AUTH_START = "AUTH_START";
export const AUTH_END = "AUTH_END";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";

export const CLEAN_UP = "CLEAN_UP";

export const CART_READY = "CART_READY";
export const TOTAL_READY = "TOTAL_READY";

export const CART_ORDER_START = "CART_ORDER_START";
export const CART_ORDER_END = "CART_ORDER_END";
export const CART_ORDER_SUCCESS = "CART_ORDER_SUCCESS";
export const CART_ORDER_FAIL = "CART_ORDER_FAIL";
